import { GetUniformLocation } from './utils/pipeline-utils-gl';
import { fragSamplerTint } from '../shaders/frag-sampler-tint.shader';
import { vertSampler } from '../shaders/vert-sampler.shader';

import { RegionMask } from './components/regionMasks/regionMask';
import { TexturePipelineBase } from './pipeline-texBase';
import { TintUniformData } from './pipeline-tinting';

export class TintedTexturePipeline extends TexturePipelineBase {
  public constructor(regionMaskColour = '') {
    super(vertSampler, fragSamplerTint);

    if (regionMaskColour) {
      this.regionMask = new RegionMask();
      this.fragShader = RegionMask.ModifyFragShaderText(this.fragShader, regionMaskColour);
    }
  }

  protected InitShaderProps(shaderProgram: WebGLProgram) {
    super.InitShaderProps(shaderProgram);

    this.shaderProgramProps.u_tintColour = GetUniformLocation(
      this.gl,
      shaderProgram,
      'uTintColour',
      this.constructor.name
    );
  }

  public Draw(uniformData: TintUniformData): void {
    super.Draw(uniformData);
  }

  public DrawOnceForPixelData(uniformData: TintUniformData): Uint8Array {
    return super.DrawOnceForPixelData(uniformData);
  }

  protected SetUniforms(tintColour: TintUniformData) {
    super.SetUniforms({});
    this.gl.uniform3fv(this.shaderProgramProps.u_tintColour, tintColour);
  }
}
